console.log('>> blog-event');

const ICON_CLOSE = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
const ICON_PREV  = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>`;
const ICON_NEXT  = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>`;

const initEventPhotoGallery = () => {
    const grids = document.querySelectorAll('.event-photos__grid[data-gallery]');
    if (!grids.length) {
        return;
    }

    const lightboxContainer = document.createElement('div');
    lightboxContainer.className = 'event-gallery-lightbox';
    lightboxContainer.setAttribute('role', 'dialog');
    lightboxContainer.setAttribute('aria-modal', 'true');
    lightboxContainer.setAttribute('aria-label', 'Photo gallery');
    lightboxContainer.setAttribute('aria-hidden', 'true');
    lightboxContainer.innerHTML = `
        <button class="event-gallery-lightbox__close" aria-label="Close gallery">${ICON_CLOSE}</button>
        <button class="event-gallery-lightbox__prev" aria-label="Previous photo">${ICON_PREV}</button>
        <div class="event-gallery-lightbox__stage">
            <img class="event-gallery-lightbox__img" src="" alt="">
        </div>
        <button class="event-gallery-lightbox__next" aria-label="Next photo">${ICON_NEXT}</button>
        <div class="event-gallery-lightbox__counter"></div>
    `;
    document.body.appendChild(lightboxContainer);

    const lightboxImg      = lightboxContainer.querySelector('.event-gallery-lightbox__img');
    const counter  = lightboxContainer.querySelector('.event-gallery-lightbox__counter');
    const closeBtn = lightboxContainer.querySelector('.event-gallery-lightbox__close');
    const prevBtn  = lightboxContainer.querySelector('.event-gallery-lightbox__prev');
    const nextBtn  = lightboxContainer.querySelector('.event-gallery-lightbox__next');

    let gallery   = [];
    let currentPhotoIndex   = 0;
    let triggerEl = null;

    const show = (index) => {
        currentPhotoIndex  = (index + gallery.length) % gallery.length;
        lightboxImg.src  = gallery[currentPhotoIndex].src;
        lightboxImg.alt  = gallery[currentPhotoIndex].alt || '';
        counter.textContent = `${currentPhotoIndex + 1} of ${gallery.length}`;
        const isSinglePhoto = gallery.length === 1;
        prevBtn.style.display = isSinglePhoto ? 'none' : '';
        nextBtn.style.display = isSinglePhoto ? 'none' : '';

        if (!isSinglePhoto) {
            const preloadNext = new Image();
            preloadNext.src = gallery[(currentPhotoIndex + 1) % gallery.length].src;
            const preloadPrev = new Image();
            preloadPrev.src = gallery[(currentPhotoIndex - 1 + gallery.length) % gallery.length].src;
        }
    };

    const open = (photos, index, trigger) => {
        gallery   = photos;
        triggerEl = trigger || null;
        show(index);
        lightboxContainer.classList.add('is-open');
        lightboxContainer.removeAttribute('aria-hidden');
        document.body.style.overflow = 'hidden';
        closeBtn.focus();
    };

    const close = () => {
        lightboxContainer.classList.remove('is-open');
        lightboxContainer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (triggerEl) {
            triggerEl.focus();
        }
    };

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', () => {
        show(currentPhotoIndex - 1);
    });
    nextBtn.addEventListener('click', () => {
        show(currentPhotoIndex + 1);
    });

    lightboxContainer.addEventListener('click', (e) => {
        if (e.target === lightboxContainer) {
            close();
        }
    });

    let touchStartX = 0;
    lightboxContainer.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
    }, { passive: true });
    lightboxContainer.addEventListener('touchend', (e) => {
        const delta = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) < 50) {
            return;
        }
        if (delta < 0) {
            show(currentPhotoIndex + 1);
        } else {
            show(currentPhotoIndex - 1);
        }
    }, { passive: true });

    document.addEventListener('keydown', (e) => {
        if (!lightboxContainer.classList.contains('is-open')) {
            return;
        }
        if (e.key === 'Escape') {
            e.preventDefault();
            close();
        }
        if (e.key === 'ArrowLeft') {
            show(currentPhotoIndex - 1);
        }
        if (e.key === 'ArrowRight') {
            show(currentPhotoIndex + 1);
        }
    });

    grids.forEach((grid) => {
        let photos;
        try {
            photos = JSON.parse(grid.getAttribute('data-gallery') || '[]');
        } catch (e) {
            return;
        }
        if (!photos.length) {
            return;
        }

        grid.querySelectorAll('.event-photos__item[data-gallery-index]').forEach((btn) => {
            btn.addEventListener('click', () => {
                const index = parseInt(btn.getAttribute('data-gallery-index'), 10);
                open(photos, index, btn);
            });
        });
    });
};

document.addEventListener('DOMContentLoaded', () => {
    initEventPhotoGallery();
});
